(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-choice-button/assets/javascripts/coupon-choice-link.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-choice-button/assets/javascripts/coupon-choice-link.js');
"use strict";


const ReactIcon = svs.ui.ReactIcon;
const TipsenLink = svs.components.tipsen.tipsen_link.TipsenLink;
const clx = svs.components.lbUtils.clx;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM;
const useBranding = svs.components.tipsen.hooks.useBranding;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const CouponChoiceLink = _ref => {
  let ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    className = _ref.className,
    icon = _ref.icon,
    _ref$to = _ref.to,
    to = _ref$to === void 0 ? {} : _ref$to;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';

  return React.createElement(TipsenLink, {
    "aria-label": ariaLabel,
    className: clx('coupon-toolbox-guide-button btn btn-300 btn-coupon-choice btn-default', className, {
      ["btn-coupon-choice-branding-".concat(branding)]: branding
    }),
    title: ariaLabel,
    to: to
  }, React.createElement("span", {
    className: "btn-link-text"
  }, React.createElement(ReactIcon, {
    icon: icon,
    size: isSmall ? 200 : 300
  }), React.createElement("span", {
    className: "btn-text"
  }, children)));
};
setGlobal('svs.components.tipsen.couponChoiceButton.CouponChoiceLink', CouponChoiceLink);

 })(window);